import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CmsAPI } from '../../api';
import { makeStyles } from '@material-ui/core/styles';
import Page from '../../components/Page';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Container from '@material-ui/core/Container';
import BlogLinkList from './components/BlogLinkList';
import BlogPostTitle from './components/BlogPostTitle';
import BlogPostContent from './components/BlogPostContent';
import BlogSearchBar from './components/BlogSearchBar';
import BlogListBlurb from './components/BlogListBlurb';
import MetaTags from '../../components/MetaTags';
import { useHistory } from 'react-router-dom';
import config from '../../config';
import ShareButtonPanel from '../../components/widgets/ShareButtonPanel';
import SuggestedServices from '../../components/suggestions/SuggestedServices';
import * as track from '../../lib/track';
import UserFeaturesCTA from '../../components/widgets/UserFeaturesCTA';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  leftColumn: {
    padding: '1rem 3rem 4rem 0',
    [theme.breakpoints.down('sm')]: {
      padding: '0 2rem 1rem 2rem',
    },
  },
  rightColumn: {
    padding: '12rem 0 4rem 2rem',
    [theme.breakpoints.down('sm')]: {
      padding: '2rem',
    },
  },
}));

const BlogPostPage = ({match}) => {
  const history = useHistory();
  const { slug } = match.params;

  // for SEO reasons we are guaranteeing a trailing slash on the path,
  // as it was on the original wordpress site.  We recognise the path
  // without the trailing / but always canonicalise it to the trailing /

  const path = '/blog/' + slug + '/';
  if (match.url !== path) {
    history.push(path);
  }
  const [content, setContent] = useState();
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    CmsAPI.getBlogPage(path).then((content) => setContent(content.payload));
  }, [path]);

  useEffect(() => {
    CmsAPI.getBlogRecent().then((content) => setRecent(content.payload));
  }, []);

  useEffect(() => {
    track.sendEvent('blog post', 'view', {slug: slug});
  }, [slug]);

  const onSearch = (query) => {
    history.push({ pathname: '/blog/search', search: '?query='+encodeURI(query)});
  };

  const classes = useStyles();
  return (
    <Page title={content ? content.title : 'Clickability Blog'}>
      {content && <MetaTags
        article
        title={content.title}
        description={content.leader}
        image={config.website.URL + content.featured_image}
        url={config.website.URL + content.path}
      />}
      <Container maxWidth="lg" fixed disableGutters={true}>
        <Grid container spacing={0}>
          <Grid item md={8} sm={12}>
            <div className={classes.leftColumn}>
              {content && <BlogPostTitle content={content}/>}
              {content && <BlogPostContent content={content}/>}
              {content && <ShareButtonPanel />}
            </div>
          </Grid>
          <Grid item md={4} sm={12}>
            <div className={classes.rightColumn}>
              <UserFeaturesCTA />
              <BlogSearchBar onSubmit={onSearch}/>
              <Divider variant="middle" />
              <SuggestedServices query={slug.split('-').join(' ')}/>
              <Divider variant="middle" />
              <BlogLinkList title="Recent posts" content={recent} />
              <Divider variant="middle" />
              <BlogListBlurb />
            </div>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

BlogPostPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.object.isRequired,
    url: PropTypes.string.isRequired,
  })
};

export default BlogPostPage;
